<template>
  <b-row>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <b-col md="12">
      <b-card>
        <div slot="header">
          <strong>Importação de Usuários que Assinam pelo PJ</strong>
        </div>
        <b-form @submit.stop.prevent>
          
          <b-form-group label="Dados para importação" label-for="importData" description="Informe a lista com CPF/CNPJ; nome; email; senha em cada linha separados por ponto e vírgula (;). Caso não possua algum dado, deixar apensa um espaço no local.">
            <b-form-textarea id="importData" v-model="importDataStr" rows="10"></b-form-textarea>
          </b-form-group>

          <div v-if="errors.length">
            <b-alert show variant="warning"><strong>Erros:</strong>
              <ul>
                <li v-for="itm in errors" :key="itm.username">
                  <strong>{{ itm.username }}: </strong> {{ itm.detail.detail }}
                </li>
              </ul>
            </b-alert>
          </div>

          <div slot="footer">
            <b-row>
              <b-col sm="12" lg="2">
                <b-button class="form-control btn-primary" type="button" @click="executeConfirm()"><i class="fa fa-upload"></i> Importar</b-button>&nbsp;
              </b-col>
            </b-row>
          </div>
        </b-form>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import axios from 'axios';
import { requestError, env } from '@/shared/utils';
import { request } from 'http';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: {
    Loading
  },
  data: () => {
    return {
      importDataStr: "",
      errors: [],
      usernamesNotFound: [],
      loadCount: 0
    }
  },
  computed: {
    isLoading() {
      return this.loadCount > 0;
    }
  },
  methods: {
    executeConfirm() {
      if (!this.importDataStr) {
        this.$bvModal.msgBoxOk('A lista de usuários deve ser preenchida')
          .then()
          .catch(console.error);
        return;
      }
      this.loadCount++;
      let lines = this.importDataStr.split(/[\r\n]+/);
      this.errors = [];
      let data = [];
      for (let i = 0; i < lines.length; i++) {
        const line = lines[i];
        let fields = line.split(/[;]/);
        if (fields.length < 4) {
          this.errors.push({username: `Linha ${i}`, detail: {detail: `Formato inválido [${line}]`}})
        } else if (fields[0].trim().length < 11) {
          this.errors.push({username: `Linha ${i}`, detail: {detail: `CPF ou CNPJ inválido [${fields[0].trim()}]`}});
        } else if (fields[3].trim().length < 4) {
          this.errors.push({username: `Linha ${i}`, detail: {detail: `A senha deve possuir 4 ou mais caracteres [${fields[3].trim()}]`}});
        } else {
          data.push({
            username: fields[0].trim(),
            name: fields[1].trim(),
            email: fields[2].trim(),
            password: fields[3].trim(),
          });
        }
      }
      this.loadCount--;
      if (this.errors.length > 0) {
        this.$bvModal.msgBoxOk('Ocorreram algumas inconsistências nos dados para importação. Verifique e importe novamente.')
          .then(value => {})
          .catch(console.error);
        return;
      }
      this.$bvModal.msgBoxConfirm(`Deseja realmente importar todos os usuários informados?`)
        .then(val => {
          val && this.execute(data);
        }).catch(console.error);
    },
    execute(data) {
      this.loadCount++;
      axios
        .patch(`${env.urlBillingApi}/user-signer`, { data })
        .then((response) => {
          this.errors = response.data._embedded.user_signer[0].errors;
          console.log(this.errors);
          if (this.errors.length == 0) {
            this.$bvModal.msgBoxOk('Ação realizada com sucesso!')
              .then(value => {
                  _this.$router.replace({path: '/users'});
              })
              .catch(console.error);
          } else {
            this.$bvModal.msgBoxOk('Ocorreram alguns problemas ao realizar a ação!')
              .then(value => {})
              .catch(console.error);
          }
        })
        .catch((error) => {
          requestError(error);
        })
        .finally(() => {
          this.loadCount--;
        });
    },
  }
}
</script>
